import { useState, useEffect } from 'react';
import { MASCOT_URL } from '../assets/mascot';

const LOGO_URL = "/kardif-logo.png";

export const SplashScreen = () => {
  const [gone, setGone] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setGone(true), 2200);
    return () => clearTimeout(t);
  }, []);
  if (gone) return null;
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[#101215] splash-fade" data-testid="splash-screen">
      <div className="absolute inset-0" style={{ background: 'radial-gradient(circle at 50% 40%, rgba(197,160,89,0.18), transparent 60%)' }} />
      <img src={MASCOT_URL} alt="KARDIF" className="relative w-40 sm:w-48 h-auto drop-shadow-2xl mascot-wave" />
      <img src={LOGO_URL} alt="KARDIF Investigation" className="relative mt-6 h-12 w-auto opacity-90" />
      <p className="relative mt-3 text-[#C5A059] text-sm font-medium tracking-wide">Les experts des diagnostics d'eau</p>
    </div>
  );
};

export default SplashScreen;
